import { MigrationAlert } from 'src/components/Migration';
import { Button } from 'src/components/ui/button';
import { useMigrations } from 'src/containers/Migrations';

const AlertMessage = () => {
  const { totalLegacyReposCount, setIsInfoModalVisible } = useMigrations();

  const onMigrationGuide = () => setIsInfoModalVisible(true);

  return (
    <MigrationAlert
      text={`You have ${totalLegacyReposCount} assets pending migration. Migrate your assets to an OAuth integration so they stay secure and appear on their corresponding escrow.`}
      action={
        <Button onClick={onMigrationGuide} size="sm" className="w-full">
          Migration guide
        </Button>
      }
      withAlertIcon={false}
    />
  );
};

export default AlertMessage;
